var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-modal',{staticClass:"confirm-modal",attrs:{"title":_vm.title || _vm.__('modal/confirm_title'),"body":_vm.text || _vm.__('modal/confirm_text'),"actions":_vm.actions,"loading":_vm.loading}})}
var staticRenderFns = []

export { render, staticRenderFns }